<template>
  <PageSection
    :use-alternate-bg-color="useAlternateBgColor"
  >
    <PageContainer>
      <PageHeading
        tag-name="h1"
        :margin-bottom="3"
      >
        {{ $t('csr.section.how.title') }}
      </PageHeading>

      <div class="mt-3">
        <PageTwoColumnsContent
          v-for="(item, index) in items"
          :key="item.image"
          :image="item.image"
          :content="item.content"
          :class="$style.item"
          :image-pull-right="index % 2 === 1"
        />
      </div>
    </PageContainer>
  </PageSection>
</template>

<script lang="ts">
import PageTwoColumnsContent, { PageTwoColumnsContentProps } from '@/scripts/pages/onepager/components/PageTwoColumnsContent.ts.vue';
import PageSection from '@/scripts/pages/onepager/components/PageSection.ts.vue';
import PageHeading from '@/scripts/pages/onepager/components/PageHeading.ts.vue';
import PageContainer from '@/scripts/pages/onepager/components/PageContainer.ts.vue';
import { CsrBaseComponent } from '../components/CsrBaseComponent';
import { HOW_SECTION_IMAGES } from '../assets/media';
import { LocaleItem } from '../types/LocaleItem';

export default CsrBaseComponent.extend({
  components: {
    PageTwoColumnsContent,
    PageSection,
    PageHeading,
    PageContainer,
  },
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const localeItems: LocaleItem[] = this.$t('csr.section.how.items');
    const items: PageTwoColumnsContentProps[] = localeItems.map((localeItem, index) => ({
      image: HOW_SECTION_IMAGES[index],
      content: localeItem,
    }));

    return {
      items,
    };
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.item {
  margin-bottom: 2rem;
}
</style>
